import { axiosPost } from '../ServiceBase';

export const getInternacionesTramitesIniciadosAutorizados = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/internaciones-tablero/internaciones',
    data,
  );
  return response;
};

export const getInternacionesTramitesPorDelegacion = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/internaciones-tablero/internaciones-por-sede',
    data,
  );
  return response;
};

export const getInternacionesTramitesPorAuditor = async (data) => {
  const response = null;
  return response;
};
